import { EIP191Signer } from '@lukso/eip191-signer.js'
import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import {
  Address,
  HexNumber,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { PrivateKey } from '@/business-logic/wallet/domain/wallet/PrivateKey'
import { TransactionData } from '../transaction/TransactionData'

const EIP191SignaturePropsSchema = z.object({
  validatorAddress: z.instanceof(Address),
  dataToSign: z.instanceof(TransactionData),
  privateKey: z.instanceof(PrivateKey),
})

type EIP191SignatureProps = z.infer<typeof EIP191SignaturePropsSchema>

export class EIP191Signature extends ValueObject<EIP191SignatureProps> {
  public getValue(): HexNumber {
    const { validatorAddress, dataToSign, privateKey } = this.props
    const privateKeyValue = privateKey.getHexValue()
    const validatorAddressValue = validatorAddress.getChecksumValue()
    const dataHexNumberValue = dataToSign.getValue()
    const dataValue = dataHexNumberValue.getValue()

    const eip191Signer = new EIP191Signer()
    const { signature: signatureValue } =
      eip191Signer.signDataWithIntendedValidator(
        validatorAddressValue,
        dataValue,
        privateKeyValue
      )

    return HexNumber.create({
      hexNumberValue: signatureValue,
    })
  }

  /**
   * Converts the signature to a base 16 hexidecimal string.
   */
  public toHexString(): string {
    return this.getValue().getValue()
  }

  public static create(props: EIP191SignatureProps): EIP191Signature {
    const validatedProps = EIP191SignaturePropsSchema.parse(props)
    return new EIP191Signature(validatedProps)
  }
}
